import useUpdatePoolTaskSubmissions from '../../../../hooks/useUpdatePoolTaskSubmissions'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'
import SharedDiscordTask, {
  Props,
} from '../../../../shared_components/Missions/Types/Discord'

export default function DiscordTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedDiscordTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
